<template>
  <div class="all">
    <!-- 區塊一 -->
    <section id="section1" class="section1">
      <subNav></subNav>
      <div class="custom-container">
        <div class="page-header" data-aos="zoom-in" data-aos-duration="800">
          <h3 class="title">SEO整體規劃</h3>
          <ul class="content">
            <li>網站分析優化</li>
            <li>關鍵字研究</li>
            <li>網路的曝光率提升</li>
            <li>策略性創意企劃</li>
            <li>社群媒體整合</li>
          </ul>
        </div>
      </div>
    </section>
    <!-- 區塊二 -->
    <section class="section2">
      <div class="custom-container">
        <h1 class="header"  data-aos="fade-up" data-aos-duration="800">為什麼要做SEO</h1>
        <div class="content"  data-aos="fade-up" data-aos-duration="800">
          <h3>你可能已經知道SEO優化，但卻不知從何著手SEO優化。</h3>
          <p>每天都有新網站、新網頁在誕生，而演算機制一變再變，這使得網路發展越來越困難重重。換句話說，如果沒有掌握到對的行銷方法與經營策略，要發展電商根本很難脫穎而出。</p>
          <p>SEO(Search Engine Optimization)
            在基於搜尋引擎的自然排名演算法上，包含技術形導向SEO及內容導向SEO，用以提高網頁排名、流量。當使用者透過該搜尋引擎搜索相關關鍵字時，能進而改善網站在搜尋引擎中的自然排名，並提升網站的更多流量，以達到網站銷售或是品牌建立的目標。</p>
        </div>
        <div class="seo-advantage d-flex">
          <div class="item" data-aos="zoom-in" data-aos-duration="800">
            <img class="seo-icon" src="/static/images/service/seo/icon_SEO1.svg" alt="">
            <div class="text">網路消費歷程是複雜的<br>你需要不同的管道來促成轉單率</div>
          </div>
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="300">
            <img class="seo-icon" src="/static/images/service/seo/icon_SEO2.svg" alt="">
            <div class="text">利用SEO改善網站體質<br>甚至是網站的使用者體驗</div>
          </div>
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="600">
            <img class="seo-icon" src="/static/images/service/seo/icon_SEO3.svg" alt="">
            <div class="text">SEO可建立更優於廣告<br>效益更持久的ROI</div>
          </div>
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="900">
            <img class="seo-icon" src="/static/images/service/seo/icon_SEO4.svg" alt="">
            <div class="text">SEO幫助建立<br>品牌形象、品牌權威度</div>
          </div>
        </div>
      </div>
    </section>
    <!-- 區塊三 -->
    <section class="section3">
      <div class="custom-container">
        <div class="seo-detail-wrap d-flex">
          <div class="seo-category" data-aos="fade-right" data-aos-duration="800">
            <h2 class="header">技術導向SEO</h2>
            <h4 class="title">在技術層面上就是要讓「Google讀懂我們的網站」：</h4>
            <ul class="category-list">
              <li>．設定301轉址</li>
              <li>．SSL的憑證設定</li>
              <li>．sitemap該要如何產生</li>
              <li>．網站速度優化</li>
            </ul>
            <p class="summary">以上這些項目都是我們在技術導向SEO領域上，常常會面臨到以及需要解決的問題，這些項目常常都需要透過工程師，修改網站的程式碼或是網站架構才能夠解決。</p>
          </div>
          <div class="seo-category" data-aos="fade-left" data-aos-duration="800">
            <h2 class="header">內容導向SEO</h2>
            <h4 class="title">內容就是王道。過去如此，現在和未來更是如此。</h4>
            <ul class="category-list">
              <li>．關鍵字研究</li>
              <li>．文案撰寫</li>
              <li>．轉換成效優化</li>
              <li>．Title/Description優化</li>
            </ul>
            <p class="summary">內容導向SEO，無法單靠程式碼就可以解決，而是需要由行銷人員規劃縝密的計畫，包括在文案撰寫的過程中融入品牌的精神，設定品牌的目標族群是誰，要先攻佔怎樣的關鍵字才是最為有效的。</p>
          </div>
        </div>
        <div class="slogan-wrap d-flex align-items-center justify-content-center" data-aos="fade-up" data-aos-duration="800">
          <div class="braces">{</div>
          <div class="text desktop">
            <h5>無極限SEO搜尋優化</h5>
            <h6>不只是要做，而是如何做得更好</h6>
          </div>
          <div class="braces">}</div>
        </div>
        <div class="how-to-better d-flex">
          <div class="item" data-aos="zoom-in" data-aos-duration="800">
            <img src="/static/images/service/seo/icon_code.svg" alt="" class="icon">
            <div class="text"> 專門工程人員<br>修改網站的程式碼</div>
          </div>
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="300">
            <img src="/static/images/service/seo/icon_insurance.svg" alt="" class="icon">
            <div class="text">行銷專員縝密規劃<br>設定品牌的目標群眾</div>
          </div>
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="600">
            <img src="/static/images/service/seo/icon_target.svg" alt="" class="icon">
            <div class="text">SSL憑證保護個資<br>幫網站買保險</div>
          </div>
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="900">
            <img src="/static/images/service/seo/icon_google.svg" alt="" class="icon">
            <div class="text">Google喜歡<br>RWD自適應網站設計</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import subNav from './subNav.vue';
  export default {
    name: 'Service-seo',
    components: {
      subNav
    },
    data() {
      return {

      }
    }
  }

</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/common.scss';
  @import 'src/assets/scss/service/seo/section1.scss';
  @import 'src/assets/scss/service/seo/section2.scss';
  @import 'src/assets/scss/service/seo/section3.scss';

  

</style>



// WEBPACK FOOTER //
// src/components/SEO.vue